import type { FunnelTemplate } from "@/lib/funnel-planner/engine";

export const highTicketCoachingTemplate: FunnelTemplate = {
  id: "high-ticket-coaching",
  serviceLine: "other",
  recommendedBands: ["growth", "enterprise"],
  pdfAccentColor: "#7C3AED",
  defaultTrafficChannels: [
    { id: "youtube",          label: "YouTube",          monthlyVisitors: 400, acquisitionType: "organic" },
    { id: "facebook_ads",       label: "Facebook / Instagram Ads", monthlyVisitors: 200, acquisitionType: "cpc", cpc: 1.50 },
    { id: "linkedin",         label: "LinkedIn",         monthlyVisitors: 150, acquisitionType: "organic" },
    { id: "email_newsletter", label: "Email Newsletter", monthlyVisitors: 100, acquisitionType: "organic" },
  ],
  defaultStages: [
    { id: "vsl-page",       conversionRate: 15, isEditable: true,  stageType: "vsl-page" },
    { id: "application-page", conversionRate: 30, isEditable: true, stageType: "opt-in-page" },
    { id: "booking-page",   conversionRate: 55, isEditable: true,  stageType: "booking-page" },
    { id: "discovery-call", conversionRate: 60, isEditable: true,  stageType: "discovery-call" },
    { id: "sales-page",     conversionRate: 25, isEditable: true,  stageType: "sales-page" },
    { id: "order-form",     conversionRate: 75, isEditable: true,  stageType: "order-form" },
    { id: "retainer-close", conversionRate: 95, isEditable: false, stageType: "retainer-close" },
  ],
};
